import { IProperty } from '../../../../data/entities/property';
import { IBathroom } from '../../../../data/entities/property/bathroom';
import { IBed } from '../../../../data/entities/property/bed';

type IBathroomForComp =
	Pick<IBathroom, 'bath_type' | 'ensuite' | 'shower_type' | 'toilet_type' | 'bathroom_number' | 'accessible' | 'private_access'>;

export const buildSubheading = (bathroom: IBathroomForComp) => {
	const contain: string[] = [];
	const noContain: string[] = [];

	bathroom.toilet_type !== 'none' ? contain.push('toilet', 'sink') : noContain.push('no toilet', 'no sink');
	bathroom.bath_type !== 'none' ? contain.push('bath') : noContain.push('no bath');
	bathroom.shower_type !== 'none' ? contain.push('shower') : noContain.push('no shower');
	bathroom.accessible ? contain.push('wheelchair accessible') : noContain.push('not wheelchair accessible');
	bathroom.private_access ? contain.push('private') : noContain.push('shared');
	const features = contain.concat(noContain);
	// Add 'and' in the last element
	let subheading = features.join(', ').replace(/,\s([^,]+)$/, ' and $1') + '. ';
	subheading = subheading + (bathroom.ensuite ? 'Ensuite.' : 'Not Ensuite.');
	subheading = subheading[0].toUpperCase() + subheading.slice(1);

	return subheading;
};

const bedSorter = (bed1: IBed, bed2: IBed) => {
	const id1 = bed1.bedroom === null ? -1 : bed1.bedroom;
	const id2 = bed2.bedroom === null ? -1 : bed2.bedroom;
	// sort by bedroom
	if (id1 > id2) return -1;
	if (id1 < id2) return 1;
	// sort by numerical ID within bedrooms
	if ((bed1.id || -1) > (bed2.id || -1)) return -1;
	if ((bed1.id || -1) < (bed2.id || -1)) return 1;
	// sort by bed type if not yet saved
	return bed1.bed_type > bed2.bed_type ? -1 : 1;
};

export const bedsToRooms = (beds: IBed[]): IBed[][] => {
	const bedrooms = [...beds]
		.map((b) => {
			const { latest_version, published_version, created_at, updated_at, ...bed } = b;
			return bed as IBed;
		})
		// sort by bedroom number for consistent rendering
		.sort(bedSorter)
		// group by bedroom number
		.reduce((grouped, bed) => ({
			...grouped,
			[bed.bedroom as number]: (grouped[bed.bedroom as number] || []).concat([bed])
		}), {} as { [key: number]: IBed[] });
	return Object.values(bedrooms);
};

export const calcFloorSpace = (property: IProperty, bedrooms: ReturnType<typeof bedsToRooms>): number => {
	const bathrooms = property.bathrooms || [];
	const raw = (bedrooms.length * 17.152) +
		(bathrooms.length * 10.000) +
		(bathrooms.filter((b) => b.toilet_type !== 'none').length * 8.596) +
		+ ((property.capacity || 0) * 0.0099);
	return Math.ceil(raw / 5) * 5;
};
